export default __webpack_public_path__ + "static/svelte-73b3684592bc619c3a03c6186df5e936.png";